<template>
    <Paper class="barcode-merge">
        <m-table
            ref="RegistrationTable"
            :pageTotal="pageTotal"
            :tableData="listData"
            :config="tableConfig"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @search="search"
            @onSearchDataChange="onSearchDataChange"
            @getTableConfigList="getTableConfigList"
            @cellClick="cellClick">
            <!-- <template v-slot:page-module-btn>
                <div class="btnList">
                    <reportExport #default="{ submit }" reportCode="">
                        <el-button
                            size="mini"
                            type="primary"
                            @click="searchExport(submit)"
                            >导出</el-button
                        >
                    </reportExport>
                </div>
            </template> -->
        </m-table>
    </Paper>
</template>

<script>
import Paper from '@/components/core/paper/Paper';
import mTable from '@/modules/sn/components/IdentityComponentCopy/Main';
import { wholeProcessTrackingSearch } from '@/modules/sn/api/lcbsManagement.js';
import { tableConfig } from './tableConfig.js';
// import formatTime from '@/utils/common.js';
import { cloneDeep } from 'lodash';
// import reportExport from '@/components/lots/reportExportPlugin';
// import { dictWithUrl } from '@/modules/sn/components/basicDataDialog/api';
import { mapGetters } from 'vuex';
import { replace } from '@/modules/sn/utils/generalOption';
import { searchByDictCodes } from '@/modules/sn/api/systemManagementApi.js';
import { fetchEyeInfoLog } from '@/modules/sn/api/productProcess.js';
export default {
    name: 'barcodeProcess',
    components: {
        Paper,
        mTable
        // reportExport
    },
    data() {
        return {
            barcodeNo: '', // 弹出框单号
            currentIndex: 0, // 弹出框下标
            pageTotal: 0, // 总条数
            listData: [], // 列表数据
            searchData: {}, // 搜索框数据
            pickerMinDate: '', // 计算禁用时间
            tableConfig: {}, // 表格配置
            listExportParams: {}, // 导出参数（默认当前查询记录）
            exportColumns: [], // 导出行
            dictObj: {}
            // shipStatusDictList: {}, // 出货状态字典
            // stateDictList: {} // 可用状态字典
        };
    },
    created() {
        this.tableConfig = tableConfig;
       this.handleDicts();
        // this.dictData();
    },
    computed: {
        ...mapGetters(['currentTenant'])
    },
    methods: {
        // 列配置
        getTableConfigList(data) {
            this.exportColumns = data;
        },
        // 检查输入参数
        checksSearchData(data) {
            if (data.barcodeNo || data.sourceBillNo || data.taskNo) {
                return true;
            }
            this.$message.warning('单据号/条码号/任务号不能同时为空');
            return false;
        },
        onSearchDataChange(data) {
            this.searchData = data;
        },
        pageChange(pageNo) {
            this.tableConfig.page.pageNo = pageNo;
            this.search(this.searchData);
        },
        sizeChange(pageSize) {
            this.tableConfig.page.pageNo = 1;
            this.tableConfig.page.pageSize = pageSize;
            this.search(this.searchData);
        },
        // 查询
        search(data) {
            const flag = this.checksSearchData(data);
            flag && this.getData(data);
        },
        getData(data) {
             const params = {
                param: cloneDeep(data),
                tenantCode: this.currentTenant.tenantCode
            };
            params.param.pageSize = this.tableConfig.page.pageSize;
            params.param.pageNo = this.tableConfig.page.pageNo;
            params.param.domainList = ['物流运输'];
            // if (params.creationDate) {
            //     params.creationDateStart = params.creationDate[0];
            //     params.creationDateEnd = params.creationDate[1];
            //     delete params.creationDate;
            // }
            if (params.param.billDate) {
                params.param.billDateStart = params.param.billDate[0];
                params.param.billDateEnd = params.param.billDate[1];
                delete params.param.billDate;
            }
            if (params.param.opDate) {
                params.param.opDateStart = params.param.opDate[0];
                params.param.opDateEnd = params.param.opDate[1];
                delete params.param.opDate;
            }
            // params.tenantCode = this.currentTenant.tenantCode;
            // params.pageSize = this.tableConfig.page.pageSize;
            // params.pageNo = this.tableConfig.page.pageNo;
            this.listExportParams = params;
            this.listData = [];
            wholeProcessTrackingSearch(params).then((res) => {
                if (res.code + '' === '0' && res.data.logisticsTransportationResp.pageResp) {
                    this.setData(res.data.logisticsTransportationResp.pageResp);
                }
            });
        },
        setData(data) {
            this.pageTotal = data.totalCount;
            this.listData = data.list.map((item) => {
                // item.state = item.state ? this.stateDictList[item.state] : '';
                // item.shipStatus = item.shipStatus
                //     ? this.shipStatusDictList[item.shipStatus]
                //     : '';
                // item.id = item.id + '';
                item.shipOrgType = this.dictObj.SN_LBCS_SHIP_ORG_TYPE[item.shipOrgType];
                item.recOrgType = this.dictObj.SN_LBCS_SHIP_ORG_TYPE[item.recOrgType];
                item.senderDetailAddrDees = item.senderDetailAddr ? replace(item.senderDetailAddr) : '';
                item.receiverDetailAddrDees = item.receiverDetailAddr ? replace(item.receiverDetailAddr) : '';
                return item;
            });
        },
        // 单元格点击查询全部单元格信息
       cellClick(data) {
            this.listData.some(item => {
                if (item.swapId === data.swapId) {
                    if (data.property.indexOf('Dees') > -1) {
                        const key = item[data.property.replace('Dees', '')];
                        if (item[data.property] !== key) {
                            if (!key) return;
                            item[data.property] = key;
                            const params = {
                                model: '条码全流程跟踪',
                                describe: `查看${data.label}`,
                                result: 'successful',
                                action: 'acces',
                                url: '/barcode/swap/wholeProcess'
                            };
                            fetchEyeInfoLog(params);
                            return true;
                        } else {
                            item[data.property] = replace(key);
                        }
                    }
                }
            });
        },
        handleDicts() {
            const params = {
                dictCodes: 'SN_LBCS_SHIP_ORG_TYPE'
            };
            searchByDictCodes(params).then((res) => {
                if (res && res.data) {
                    Object.keys(res.data).forEach((key) => {
                        const obj = {};
                        res.data[key].forEach((item) => {
                            obj[item.code] = item.name;
                        });
                        this.dictObj[key] = obj;
                    });
                }
            });
        }
        // // 导出
        // searchExport(submit) {
        //     this.exportColumns.forEach((item) => {
        //         if (!item.hiddenColumn) {
        //             columns.push(item.prop);
        //         }
        //     });
        //         EXPORT_API,
        //         columns: columns,
        //         ...this.listExportParams
        //     };
        //     if (!this.listData.length) {
        //         this.$message.warning(
        //             this.$translate('lang.EXC202101260002', {
        //                 defaultText: '暂无导出数据,请重新设置查询条件'
        //             })
        //         );
        //         return;
        //     }
        //     submit(params);
        // }
    }
};
</script>

<style lang="less" scoped>
.barcode-merge {
    /deep/ .el-table {
        height: calc(100vh - 220px) !important;
    }
}
</style>
